export const toHalfWidthDigits = (value) =>
  value.replace(/[０-９]/g, (s) => String.fromCharCode(s.charCodeAt(0) - 65248));
